import { useTranslation } from "react-i18next";

const WhyChooseUS = () => {
  const { t } = useTranslation();

  return (
    <article className="relative py-28 ">
      <img
        src="/assets/shipping.png"
        alt="Shipping"
        className="absolute top-0 left-0 object-cover w-full h-full"
      />
      <div className="relative z-10 w-11/12 h-full mx-auto">
        <section className="text-white ">
          <h2 className="text-[32px] font-semibold my-4">{t("whyChooseUs")}</h2>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-5">
            <div className="p-7 text-center bg-white rounded-2xl min-h-[150px] grid place-content-center">
              <h2 className="text-mainRed font-bold text-[32px]">26+</h2>
              <p className="text-mainBlue">{t("yearsOfExp")}</p>
            </div>
            <div className="p-7 text-center bg-white rounded-2xl min-h-[150px] grid place-content-center">
              <h2 className="text-mainRed font-bold text-[32px]">99%</h2>
              <p className="text-mainBlue">{t("successRate")}</p>
            </div>
            <div className="p-7 text-center bg-white rounded-2xl min-h-[150px] grid place-content-center">
              <h2 className="text-mainRed font-bold text-[32px]">86%</h2>
              <p className="text-mainBlue">{t("countriesCovered")}</p>
            </div>
            <div className="p-7 text-center bg-white rounded-2xl min-h-[150px] grid place-content-center">
              <h2 className="text-mainRed font-bold text-[32px]">90%</h2>
              <p className="text-mainBlue">{t("customerSatisfaction")}</p>
            </div>
            <div className="p-7 text-center bg-white rounded-2xl min-h-[150px] grid place-content-center">
              <h2 className="text-mainRed font-bold text-[32px]">65%</h2>
              <p className="text-mainBlue">{t("overseasCustomer")}</p>
            </div>
          </div>
        </section>
      </div>
    </article>
  );
};

export default WhyChooseUS;
